import React, { useEffect, useState } from "react";
import ModalWindow from "../../shared/ModalWindow";

import style from "./style.module.scss";
import OrdersSectionItemInfoColumn from "../../orders/section-item/components/OrdersSectionItemInfoColumn";
import { Aviation, Order, User } from "../../../services";
import cn from "classnames";
import { toast } from "react-toastify";
import Loading from "../../shared/Loading/Loading";
import { get } from "../../../services/config";
import { useSelector } from "react-redux";
import { requestErrorDisplay } from "../../../utils";
import CustomSelect from "../../custom/custom-select";
import CustomInput from "../../custom/custom-input/CustomInput";
import AddAddress from "./components/AddAddress";
import { t } from "i18next";
import { useLanguage } from "../../../context/LanguageContext";

const OrdersLocationAddModal = ({
  onClose,
  updateContent,
  searchText = "",
  titleEnd = "",
  isSender = false,
  setLoadingAddress = false,
  countries = [],
  countrySelected,
  citySelected,
  onChangeCity,
  onChangeCountry,
}) => {
  const { currentLanguage } = useLanguage();
  const [name, setName] = useState(null);
  const [country, setCountry] = useState(countrySelected);
  const [binData, setBinData] = useState();
  const [cities, setCities] = useState();
  const [city, setCity] = useState(citySelected);
  const [address, setAddress] = useState(searchText || null);
  const [coordinates, setCoordinates] = useState("");
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  // useEffect(() => {
  //   if (user?.id && isSender) {
  //     setPhone(user?.phoneNumber || null);
  //   }
  //   setEmail(user?.email || null);
  // }, [user, isSender]);

  useEffect(() => {
    if (country?.id) {
      Order.getCities(currentLanguage, country.id)
        .then((response) => {
          console.log("cities 111", country, response);
          setCities(
            response.data.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            }),
          );
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });
    } else {
      setCities([]);
    }
  }, [country]);

  const validationData = () => {
    setErrors(null);
    const newErrors = {};
    let allow = true;

    if (!name) {
      toast.error(t("addressOrder.enterOrganizationName"));
      newErrors.name = t("addressOrder.enterOrganizationName");
      allow = false;
    }
    if (!phone) {
      toast.error(t("addressOrder.enterPhone"));
      newErrors.phone = t("addressOrder.enterPhone");
      allow = false;
    }
    if (!address) {
      toast.error(t("addressOrder.enterAddress"));
      newErrors.address = t("addressOrder.enterAddress");
      allow = false;
    }
    if (!country?.id) {
      toast.error(t("addressOrder.country"));
      newErrors.country = t("addressOrder.selectOption");
      allow = false;
    }
    if (!city?.id) {
      toast.error(t("addressOrder.city"));
      newErrors.city = t("addressOrder.selectOption");
      allow = false;
    }

    setErrors(newErrors);
    return allow;
  };

  const submitHandle = () => {
    if (!validationData()) {
      return;
    }

    const formData = {
      countryId: country?.id,
      cityId: city?.id,
      phoneNumber: phone.replace(/\D/g, ''),
      email: email,
      fullAddress: address,
      latLng: coordinates,
      name: name
    };
    if (isSender) {
      formData["type"] = 0;
    } else {
      formData["type"] = 1;
    }

    setLoading(true);
    Order.getUserAddressCreate(formData)
      .then((res) => res.data)
      .then((response) => {
        toast.info(t("addressOrder.recordCreated"));
        updateContent(response);
        console.log("submit", country, response);
      })
      .catch((error) => {
        requestErrorDisplay(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ModalWindow onClose={onClose} style={{ marginTop: "210px" }}>
      <div className={style.modal}>
        <h3>{t("addressOrder.addAddress")} {titleEnd}</h3>

        <OrdersSectionItemInfoColumn>
          <CustomInput
            labelText={t("addressOrder.organizationName")}
            placeholder={t("addressOrder.enterOrganizationName")}
            isBgGray
            value={name}
            onChangeValue={setName}
            errorText={errors?.name}
          />
        </OrdersSectionItemInfoColumn>

        <OrdersSectionItemInfoColumn>
          <CustomSelect
            labelText={t("addressOrder.country")}
            placeholder={t("addressOrder.selectOption")}
            options={countries}
            defaultValue={country}
            onSubmit={(country) => {
              setCountry(country);
              setCity(null);
              onChangeCountry(country);
            }}
            errorText={errors?.country}
            returnObject
          />
        </OrdersSectionItemInfoColumn>

        <OrdersSectionItemInfoColumn>
          <CustomSelect
            key={city?.id}
            labelText={t("addressOrder.city")}
            placeholder={t("addressOrder.selectOption")}
            options={cities}
            defaultValue={city}
            onSubmit={(city) => {
              setCity(city);
              onChangeCity(city);
            }}
            isDisabled={!country}
            errorText={errors?.city}
            returnObject
          />
        </OrdersSectionItemInfoColumn>

        <OrdersSectionItemInfoColumn>
          <CustomInput
            labelText={t("addressOrder.addressLabel")}
            placeholder={t("addressOrder.enterAddress")}
            isBgGray
            value={address}
            onChangeValue={setAddress}
            errorText={errors?.address}
          />
        </OrdersSectionItemInfoColumn>

        <OrdersSectionItemInfoColumn>
          <CustomInput
            labelText={t("addressOrder.contactPhone")}
            placeholder={t("addressOrder.enterPhone")}
            inputType="text"
            isBgGray
            value={phone}
            isPhone={false}
            onChangeValue={(value) => {
              const numericValue = value.replace(/[^0-9+()]/g, "");
              setPhone(numericValue);
            }}
            errorText={errors?.phone}
          />
        </OrdersSectionItemInfoColumn>

        <OrdersSectionItemInfoColumn>
          <CustomInput
            labelText={t("addressOrder.emailOptional")}
            placeholder={t("addressOrder.enterEmail")}
            inputType="text"
            onChangeValue={setEmail}
            value={email}
            errorText={errors?.email}
            isBgGray
          />
        </OrdersSectionItemInfoColumn>

        <button
          type="button"
          className={cn(style.modal_button, {
            [style.modal_button_disabled]: !country,
          })}
          onClick={submitHandle}
        >
          {isLoading ? <Loading inBlock marginBottom={0} /> : t("addressOrder.saveAddress")}
        </button>
      </div>
    </ModalWindow>
  );
};

export default OrdersLocationAddModal;
